import type { ReactNode } from 'react';

import type { InGameCurrency } from '__generated__/globalTypes';
import { Boost } from 'atoms/icons/Boost';
import { isXPCurrency } from 'lib/rewards';
import { inGameCurrencyToRarity } from 'lib/scarcity';

import { CurrencyBalance } from '../CurrencyBalance';

type Props = { currency: InGameCurrency; amount: number };

export const InGameCurrencyBalance = ({ currency, amount }: Props) => {
  const rarity = inGameCurrencyToRarity[currency];
  let icon: ReactNode;
  if (isXPCurrency(currency) && rarity) {
    icon = <Boost rarity={rarity} size={2} />;
  }

  return <CurrencyBalance amount={amount} icon={icon} />;
};
